import React, { useState, useRef, useEffect } from 'react';
import { 
  Ellipsis, 
  Archive, 
  RefreshCcw
} from 'lucide-react'

const PopinProjectMenu = ({ 
  onArchiveClick, 
  onDeleteClick, 
  onRestartClick, 
  isArchived,
  ampSection
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleOnArchiveClick = () => {
    onArchiveClick();
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={menuRef}>
      <div
        className="ml-3 bg-white hover:bg-sky-500 hover:text-white text-stone-700 rounded-xl p-1 border-2 border-stone-200 hover:border-sky-500 cursor-pointer"
        onClick={toggleMenu}
      >
        <Ellipsis size={20} />
      </div>
      {isOpen && (
        <div className="absolute right-0 top-full z-10 mb-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
          <div className="py-2" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
            <button
              data-amp-track-section={ampSection}
              data-amp-track-action="Restart_Project_Click"
              data-amp-track-description="Restart Project"
              onClick={() => onRestartClick()}
              className="flex items-center px-2 py-2 bg-transparent text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 w-full text-left"
            >
              <RefreshCcw size={14} className="mr-2" /> 
              <span className="text-gray-700">Restart Project</span>
            </button>
            <button
              data-amp-track-section={ampSection}
              data-amp-track-action="Archive_Project_Click"
              data-amp-track-description="Archive Project"
              onClick={handleOnArchiveClick}
              className="flex items-center px-2 py-2 bg-transparent text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 w-full text-left"
              role="menuitem"
            >
              <Archive size={14} className="mr-2" />
              <span className="text-gray-700">
                {isArchived ? 'Unarchive Project' : 'Archive Project'}
              </span>
            </button>
            {/* <button
              onClick={handleOnDeleteClick}
              className="flex items-center px-2 py-2 bg-transparent text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 w-full text-left"
              role="menuitem"
            >
              <Trash className="w-4 h-4 mr-2" />
              <span className="text-red-500">Delete Project</span>
            </button> */}
          </div>
          <div className="absolute top-[-6px] right-4 w-3 h-3 bg-white transform rotate-45 border-l border-t border-black border-opacity-5"></div>
        </div>
      )}
    </div>
  );
};

export default PopinProjectMenu;
